export default __webpack_public_path__ + "images/best-time-for-protein-profile.png";